import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'ghost' | 'danger' | 'sage';
type Size = 'sm' | 'md';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant;
  size?: Size;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
};

const variantClasses: Record<Variant, string> = {
  primary: 'bg-ink-900 text-cream-100 hover:bg-ink-700 shadow-card-sm',
  ghost:   'bg-cream-50 text-ink-900 border border-ink-200 hover:bg-cream-100 shadow-card-sm',
  danger:  'bg-rose-500 text-cream-50 hover:bg-rose-700 shadow-card-sm',
  sage:    'bg-sage-500 text-cream-50 hover:bg-sage-700 shadow-card-sm',
};

const sizeClasses: Record<Size, string> = {
  sm: 'px-3 py-1.5 text-sm rounded-lg gap-1.5',
  md: 'px-4 py-2.5 text-sm rounded-lg gap-2',
};

export default function Button({
  variant = 'ghost',
  size = 'md',
  iconLeft,
  iconRight,
  children,
  className = '',
  ...rest
}: ButtonProps) {
  return (
    <button
      className={`inline-flex items-center justify-center font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}
      {...rest}
    >
      {iconLeft}
      {children}
      {iconRight}
    </button>
  );
}
